<template>
  <v-container v-if="!loadingProduto">
    <v-row dense>
      <v-col cols="12" sm="11">
        <px-autocomplete-fornecedor class="required rounded-tag-small"
                                    dense
                                    v-model="fornecedor"
                                    path="fornecedor/score"
                                    :error="$v.fornecedor.$error"
                                    @blur="$v.fornecedor.$touch()"/>
      </v-col>
      <v-col cols="12" sm="1" align-self="center">
        <v-btn color="primary"
               small
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickAdd">
          <v-icon x-small>mdi-plus</v-icon>
          Adicionar
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" v-if="produto.fornecedores.length > 0">
        <px-lista-fornecedor :fornecedores="produto.fornecedores"
                             @remove="onRemove($event)"
                             :loading="loading"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import validationMixin from '@/mixins/validation-mixin';
import { required } from 'vuelidate/lib/validators';
import FornecedorService from '../../fornecedor/fornecedor-produto-service';
import ListaFornecedor from '../../fornecedor/ListaFornecedor.vue';

export default {
  mixins: [validationMixin],
  props: {
    produto: Object,
    loadingProduto: Boolean,
  },
  data() {
    return {
      fornecedor: null,
      loading: false,
    };
  },
  methods: {
    buildFornecedor(fornecedor) {
      return {
        produto: {
          id: this.produto.id,
        },
        fornecedor: {
          id: fornecedor.id,
          pessoa: fornecedor.pessoa,
          site: fornecedor.site,
          disabled: fornecedor.disabled,
        },
      };
    },
    buildQueryFornecedor() {
      if (this.produto.id) {
        return `produto.id = ${this.produto.id}`;
      }
      return '';
    },
    buildParams() {
      return {
        params: {
          limit: 10,
          offset: 0,
          query: this.buildQueryFornecedor(),
        },
      };
    },
    getFornecedores() {
      this.loading = true;

      FornecedorService.get(this.buildParams())
        .then((response) => {
          this.produto.fornecedores = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickAdd() {
      if (this.validateForm()) {
        return;
      }
      if (this.produto.fornecedores.map(fornecedor => fornecedor.fornecedor.id)
        .includes(this.fornecedor.id) && !this.produto.id) {
        this.$toast(`Fornecedor ${this.fornecedor.pessoa.nome} já incluso`, { color: 'error' });
        this.fornecedor = null;
        return;
      }
      if (!this.produto.id) {
        this.produto.fornecedores.push(this.buildFornecedor(this.fornecedor));
        this.fornecedor = null;
        return;
      }
      this.save();
    },
    save() {
      this.loading = true;
      FornecedorService.save(this.buildFornecedor(this.fornecedor))
        .then(() => {
          this.$toast('Fornecedor adicionado ao produto', { color: 'success' });
          this.fornecedor = null;
        })
        .finally(() => {
          this.loading = false;
          this.getFornecedores();
        });
    },
    onRemove(fornecedor) {
      if (!this.produto.id) {
        const index = this.produto.fornecedores
          .map(fornecedorAdicionado => fornecedorAdicionado.fornecedor.id)
          .indexOf(fornecedor.fornecedor.id);
        this.produto.fornecedores.splice(index, 1);
        return;
      }
      this.remove(fornecedor);
    },
    remove(fornecedor) {
      this.loading = true;
      FornecedorService.remover(fornecedor.id)
        .then(() => {
          this.$toast('Fornecedor removido', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
          this.getFornecedores();
        });
    },
  },
  validations: {
    fornecedor: {
      required,
    },
  },
  components: {
    pxListaFornecedor: ListaFornecedor,
  },
};
</script>
